export default {"src":"/_next/static/media/checkRoseFilled.907b81e9.svg","height":25,"width":25};